export const CLIENT_ID = `${process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID}`
export const COGNITO_DEVICE_CALL_COMPLETED = 10
